import React, { useEffect, useState } from "react";
import "./Layout.scss";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import logo from "../../Assets/logoaward.png";
import overview from "../../Assets/overview.png";
import manage from "../../Assets/manage.png";
import coupann from "../../Assets/coupann.png";
import { RxDashboard } from "react-icons/rx";
import { Sidemenu, Sidesubmenu } from "../../Components/Global/GlobalText";
import event from "../../Assets/event.png";
import { LuGraduationCap } from "react-icons/lu";
import { MdOutlineLogout } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  userCheckAction,
  userDataAction,
  UserDetails,
  userFlowCheckAction,
  userFlowDataAction,
} from "../../Components/Redux/Users/action";
import { IoIosArrowForward } from "react-icons/io";
import { matchPath } from "react-router-dom";

export const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const userCheck = useSelector((state) => state?.users?.userCheck);
  const token = localStorage.getItem("token");
  const userFlowCheck = useSelector((state) => state?.users?.userFlowCheck);
  const userFlowtoken = localStorage.getItem("token");

  const { prefix } = useParams();

  const location = useLocation();
  const isUserSubmissionDetails =
    location.pathname === "/user-submission-details";

  const excludedPaths = [
    "/jury-score-board",
    "/jury-entry-listing",
    "/jury-dashboard",
    "/EventURL/.*",
    "/EventURL/.*/.*",
    "/user-registration-details",
    "/user-submission-details",
    "/404",
  ];

  const isExcludedRoute = excludedPaths.some((path) =>
    new RegExp(`^${path}(/.*)?$`).test(location.pathname)
  );

  // Route categories
  const simplifiedRoutes = ["/dashboard", "/my-events", "/admin-profile"];
  const fullAdminRoutes = [
    "/event-overview",
    "/event-details",
    "/award-category",
    "/forms",
    "/jury-round",
    "/jury-assignment",
    "/customise-allocation",
    "/nominee-listing",
    "/order-list",
    "/finance-report",
    "/jury-score-report",
    "/entry-form-report",
    "/coupans",
    "/get-all-coupans",
    "/create-jury-round-post",
    "/successfully-created-judge-round",
    "/entry-form-listing",
    "/update-jury-post/.*",
    "/user-dashboard",
    "/payment-history",
    "/shortlist-entry-form",
    "/create-jury-group",
    "/view-group",
    "/plan",
    "/submission",
    "/templates",
    "/templates/edit/.*", // 👈 ADD THIS
    "/manual-payment",

  ];

  const isSimplifiedRoute = simplifiedRoutes.includes(location.pathname);
  const isFullAdminRoute = fullAdminRoutes.some((route) =>
    new RegExp(`^${route}$`).test(location.pathname)
  );

  const navigate = useNavigate();

  const [selectedLink, setSelectedLink] = useState("dashboard");
  const [userselectedLink, setUserSelectedLink] = useState("dashboard");
  const [manageEvent, setManageEvent] = useState(false);
  const [manageJury, setManageJury] = useState(false);
  const [manageEntryForm, setManageEntryForm] = useState(false);
  const [manageReports, setManageReports] = useState(false);
  const [manageCoupans, setManageCoupans] = useState(false);

  const toggleVisibility = (menu) => {
    setManageEvent(menu === "event" ? !manageEvent : false);
    setManageJury(menu === "jury" ? !manageJury : false);
    setManageEntryForm(menu === "entryform" ? !manageEntryForm : false);
    setManageReports(menu === "reports" ? !manageReports : false);
    setManageCoupans(menu === "coupansall" ? !manageCoupans : false);

  };

  const handleLinkClick = (link) => {
    setSelectedLink(link);
  };

  const handleUserLinkClick = (link) => {
    setUserSelectedLink(link);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    dispatch(userCheckAction(false));
    dispatch(UserDetails(""));
    dispatch(userDataAction(""));
    navigate("/admin-login");
  };

  const handleUserFlowLogout = () => {
    localStorage.removeItem("token");
    dispatch(userFlowCheckAction(false));
    dispatch(UserDetails(""));
    dispatch(userFlowDataAction(""));
    navigate("/");
  };

  useEffect(() => {
    const path = location.pathname;
    const routeMappings = {
      "/event-overview": "eventoverview",
      "/event-details": "eventdetails",
      "/award-category": "awardcategory",
      "/forms": "forms",
      "/plan": "plan",
      "/jury-round": "juryrounds",
      "/jury-assignment": "juryassignment",
      "/customise-allocation": "customiseallocation",
      "/nominee-listing": "nominee",
      "/order-list": "orders",
      "/finance-report": "financereport",
      "/jury-score-report": "juryscorereport",
      "/entry-form-report": "entryformreport",
      "/coupans": "coupans",
      "/get-all-coupans": "getallcoupans",
      "/create-jury-round-post": "juryrounds",
      "/successfully-created-judge-round": "juryrounds",
      "/entry-form-listing": "entryListingForm-report",
      "/my-events": "myevents",
      "/admin-profile": "adminprofile",
      "/shortlist-entry-form": "juryrounds",
      "/create-jury-group": "juryrounds",
      "/view-group": "juryrounds",
      "/templates": "template",
      "/templates/edit/.*": "template", // 👈 ADD THIS
      "/manual-payment": "manualpayment",

    };

    const matchedPath = Object.keys(routeMappings).find(key =>
      matchPath({ path: key }, path)
    );

    setSelectedLink(matchedPath ? routeMappings[matchedPath] : "dashboard");
  }, [location.pathname]);

  const isUserLoggedIn = Boolean(token);
  const shouldShowSidebar = isUserLoggedIn &&
    (isSimplifiedRoute || isFullAdminRoute) &&
    !isExcludedRoute;

  return (
    <div className="main_bar">
      {!isExcludedRoute && shouldShowSidebar && (
        <>
          {userCheck && token ? (
            <>
              {isSimplifiedRoute ? (
                // Simplified Sidebar
                <div className="sideBar">
                  <div className="logo_img">
                    <img src={logo} alt="logo" />
                  </div>
                  <div className="menu_div">
                    <div className="menu_click_div">
                      <Link
                        to="/dashboard"
                        className={selectedLink === "dashboard" ? "selected" : ""}
                        onClick={() => handleLinkClick("dashboard")}
                      >
                        <RxDashboard />
                        <span><Sidemenu className="s-color">Dashboard</Sidemenu></span>
                      </Link>

                      <Link
                        to="/my-events"
                        className={selectedLink === "myevents" ? "selected" : ""}
                        onClick={() => handleLinkClick("myevents")}
                      >
                        <img src={event} alt="event_icon" />
                        <span><Sidemenu className="s-color">My Events</Sidemenu></span>
                      </Link>

                      <Link
                        to="/admin-profile"
                        className={selectedLink === "adminprofile" ? "selected" : ""}
                        onClick={() => handleLinkClick("adminprofile")}
                      >
                        <LuGraduationCap style={{ height: "20px" }} />
                        <span><Sidemenu>Admin Profile</Sidemenu></span>
                      </Link>
                    </div>

                    <div className="Logout_main_div">
                      <div className="logout_div" onClick={handleLogout}>
                        <MdOutlineLogout />
                        <span><Sidemenu className="s-color">Logout</Sidemenu></span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : isFullAdminRoute ? (
                // Full Admin Sidebar
                <div className="sideBar">
                  <div className="logo_img">
                    <img src={logo} alt="logo" />
                  </div>
                  <div className="menu_div">
                    <div className="menu_click_div">
                      {/* Dashboard Link */}
                      <Link
                        to="/dashboard"
                        className={selectedLink === "dashboard" ? "selected" : ""}
                        onClick={() => handleLinkClick("dashboard")}
                      >
                        <RxDashboard />
                        <span><Sidemenu className="s-color">Dashboard</Sidemenu></span>
                      </Link>

                      {/* My Events Link */}
                      <Link
                        to="/my-events"
                        className={selectedLink === "myevents" ? "selected" : ""}
                        onClick={() => handleLinkClick("myevents")}
                      >
                        <img src={event} alt="event_icon" />
                        <span><Sidemenu className="s-color">My Events</Sidemenu></span>
                      </Link>

                      {/* Admin Profile Link */}
                      <Link
                        to="/admin-profile"
                        className={selectedLink === "adminprofile" ? "selected" : ""}
                        onClick={() => handleLinkClick("adminprofile")}
                      >
                        <LuGraduationCap style={{ height: "20px" }} />
                        <span><Sidemenu>Admin Profile</Sidemenu></span>
                      </Link>

                      {/* Full Admin Menu Items */}
                      <Link
                        to="/event-overview"
                        className={selectedLink === "eventoverview" ? "selected" : ""}
                        onClick={() => handleLinkClick("eventoverview")}
                      >
                        <img src={overview} alt="event_icon" />
                        <span><Sidemenu className="s-color">Event Overview</Sidemenu></span>
                      </Link>

                      {/* Manage Event Section */}
                      <Link onClick={() => toggleVisibility("event")}>
                        <img src={event} alt="event_icon" />
                        <span><Sidemenu className="s-color">Manage Event</Sidemenu></span>
                      </Link>

                      {manageEvent && (
                        <>
                          <Link
                            to="/event-details"
                            className={selectedLink === "eventdetails" ? "selected" : ""}
                            onClick={() => handleLinkClick("eventdetails")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Event Details</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/plan"
                            className={selectedLink === "plan" ? "selected" : ""}
                            onClick={() => handleLinkClick("plan")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Manage Event Plan</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/award-category"
                            className={selectedLink === "awardcategory" ? "selected" : ""}
                            onClick={() => handleLinkClick("awardcategory")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Award Categories</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/forms"
                            className={selectedLink === "forms" ? "selected" : ""}
                            onClick={() => handleLinkClick("forms")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Forms</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/templates"
                            className={selectedLink === "template" ? "selected" : ""}
                            onClick={() => handleLinkClick("template")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Templates</Sidesubmenu></span>
                          </Link>

                        </>
                      )}

                      {/* Manage Jury Section */}
                      <Link onClick={() => toggleVisibility("jury")}>
                        <img src={manage} alt="manage_icon" />
                        <span><Sidemenu className="s-color">Manage Jury</Sidemenu></span>
                      </Link>

                      {manageJury && (
                        <>
                          <Link
                            to="/jury-round"
                            className={selectedLink === "juryrounds" ? "selected" : ""}
                            onClick={() => handleLinkClick("juryrounds")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Jury Rounds</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/jury-assignment"
                            className={selectedLink === "juryassignment" ? "selected" : ""}
                            onClick={() => handleLinkClick("juryassignment")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Jury Assignment</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/customise-allocation"
                            className={selectedLink === "customiseallocation" ? "selected" : ""}
                            onClick={() => handleLinkClick("customiseallocation")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Customise Allocation</Sidesubmenu></span>
                          </Link>
                        </>
                      )}

                      {/* Manage Entry Form Start */}
                      <Link onClick={() => toggleVisibility("entryform")}>
                        <img src={manage} alt="manage_icon" />
                        <span><Sidemenu className="s-color">Manage Entry Form</Sidemenu></span>
                      </Link>

                      {manageEntryForm && (
                        <>
                          <Link
                            to="/nominee-listing"
                            className={selectedLink === "nominee" ? "selected" : ""}
                            onClick={() => handleLinkClick("nominee")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Nominee</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/entry-form-listing"
                            className={selectedLink === "entryListingForm-report" ? "selected" : ""}
                            onClick={() => handleLinkClick("entryListingForm-report")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Entry Form Listing Report</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/order-list"
                            className={selectedLink === "orders" ? "selected" : ""}
                            onClick={() => handleLinkClick("orders")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Orders</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/manual-payment"
                            className={selectedLink === "manualpayment" ? "selected" : ""}
                            onClick={() => handleLinkClick("manualpayment")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span>
                              <Sidesubmenu>Manual Payments</Sidesubmenu>
                            </span>
                          </Link>
                        </>
                      )}
                      {/* Manage Entry Form End */}

                      {/* Manage Reports Start */}
                      <Link onClick={() => toggleVisibility("reports")}>
                        <img src={manage} alt="manage_icon" />
                        <span><Sidemenu className="s-color">Manage Reports</Sidemenu></span>
                      </Link>

                      {manageReports && (
                        <>
                          <Link
                            to="/finance-report"
                            className={selectedLink === "financereport" ? "selected" : ""}
                            onClick={() => handleLinkClick("financereport")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Finance Report</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/jury-score-report"
                            className={selectedLink === "juryscorereport" ? "selected" : ""}
                            onClick={() => handleLinkClick("juryscorereport")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Jury Score Report</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/entry-form-report"
                            className={selectedLink === "entryformreport" ? "selected" : ""}
                            onClick={() => handleLinkClick("entryformreport")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Entry Form Report</Sidesubmenu></span>
                          </Link>
                        </>
                      )}
                      {/* Manage Reports End */}

                      {/* Manage Coupan Start */}

                      <Link onClick={() => toggleVisibility("coupansall")}>
                        <img src={manage} alt="manage_icon" />
                        <span><Sidemenu className="s-color">Manage Coupans</Sidemenu></span>
                      </Link>

                      {manageCoupans && (
                        <>
                          <Link
                            to="/coupans"
                            className={selectedLink === "coupans" ? "selected" : ""}
                            onClick={() => handleLinkClick("coupans")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>Create Coupan</Sidesubmenu></span>
                          </Link>

                          <Link
                            to="/get-all-coupans"
                            className={selectedLink === "getallcoupans" ? "selected" : ""}
                            onClick={() => handleLinkClick("getallcoupans")}
                            style={{ marginLeft: "10px" }}
                          >
                            <IoIosArrowForward />
                            <span><Sidesubmenu>All Coupans</Sidesubmenu></span>
                          </Link>


                        </>
                      )}

                    </div>

                    <div className="Logout_main_div">
                      <div className="logout_div" onClick={handleLogout}>
                        <MdOutlineLogout />
                        <span><Sidemenu className="s-color">Logout</Sidemenu></span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </>
          ) : null}

          {userFlowCheck && userFlowtoken && !isUserSubmissionDetails && (
            <div className="sideBar">
              <div className="logo_img">
                <img src={logo} alt="logo" />
              </div>

              <div className="menu_div">
                <div className="menu_click_div">
                  <Link
                    to="/user-dashboard"
                    className={
                      userselectedLink === "dashboard" ? "selected" : ""
                    }
                    onClick={() => handleUserLinkClick("dashboard")}
                  >
                    <RxDashboard />
                    <span>
                      <Sidemenu className="s-color">Dashboard</Sidemenu>
                    </span>
                  </Link>

                  <Link
                    to="/payment-history"
                    className={
                      userselectedLink === "paymentHistory" ? "selected" : ""
                    }
                    onClick={() => handleUserLinkClick("paymentHistory")}
                  >
                    <RxDashboard />
                    <span>
                      <Sidemenu className="s-color">Payment History</Sidemenu>
                    </span>
                  </Link>

                  <Link
                    to="/submission"
                    className={userselectedLink === "/test1" ? "selected" : "/"}
                  >
                    <img src={event} alt="event_icon" />
                    <span>
                      <Sidemenu className="s-color">
                        Submission Details
                      </Sidemenu>
                    </span>
                  </Link>
                </div>

                <div className="Logout_main_div">
                  {userFlowCheck && userFlowtoken ? (
                    <div
                      className="logout_div"
                      onClick={handleUserFlowLogout}
                    >
                      <MdOutlineLogout />
                      <span>
                        <Sidemenu className="s-color">Logout</Sidemenu>
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}

      <div className="main_body">{children}</div>
    </div>
  );
};